module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1127.7a47dde8.png";